<template>
  <div class="methodedetail">
    <subNav :subnavstep="subnavstep"></subNav>
    <div class="methodedetail-header">
      <router-link
        :to="{
          name: 'methodes',
          params: { doelSlug: slug },
        }"
        :key="methode.id"
        class="backButton"
      ></router-link>
      <div class="choiceFieldset">
        <input
          type="checkbox"
          name="methodCheckbox"
          :value="methode.id"
          :id="checkboxValue"
          :checked="checked"
          v-on:change="saveMethod"
        />
        <label :for="checkboxValue" :id="methode.id" v-if="checked"
          >verwijderen uit vergelijking ({{ countSelected }})</label
        >
        <label :for="checkboxValue" :id="methode.id" v-else
          >toevoegen aan vergelijking ({{ countSelected }})</label
        >
      </div>
      <h1>{{ methode.name }}</h1>
      <div v-html="methode.description"></div>
    </div>

    <div class="qualities-tips">
      <div class="qualities-tips__left">
        <div class="qualities">
          <h4>Democratische waarden</h4>
          <ul class="qualities__list">
            <li
              v-for="(waarde, index) in methode.values"
              :key="waarde.i"
              class="quality-row"
              v-bind:class="{ active: active == waarde }"
            >
              <div class="quality">
                <span
                  class="quality-icon"
                  :class="'icon-' + cleanClass(waarde.waarde)"
                ></span>
                <span @click="getTipsWaarde(index, waarde)" class="quality-text link">{{
                  waarde.waarde
                }}</span>

                <span class="quality-scores">
                  <span
                    class="star"
                    v-for="n in parseInt(waarde.score)"
                    :key="n"
                  ></span>
                  <span
                    class="star star--empty"
                    v-for="n in parseInt(5 - waarde.score)"
                    :key="n + 10"
                  ></span>
                </span>
              </div>
              <div class="quality-explained">
                {{ waarde.kort }}
                <span class="more" @click="showLightboxDemoWaarden(index)"
                  >Meer weten?</span
                >
              </div>
            </li>
          </ul>
        </div>
      </div>

      <div class="qualities-tips__right">
        <TipCard :tipdata="tipsArray" :hiddenTips="hiddenTips"></TipCard>
      </div>
    </div>
  </div>
</template>

<script>
import subNav from "../components/subNav.vue";
import TipCard from "../components/TipCard.vue";

const ENDPOINT_NAME = "ppw/v1/methode";
const axios = require("axios");

export default {
  name: "methodeDetail",

  data() {
    return {
      methode: [],
      tips: "",
      tipsArray: [],
      active: 0,
      storeMethods: [],
      storeIndex: 0,
      countSelected: 0,
      hiddenTips: [],
      slug: "",
      subnavstep: "methodes",
    };
  },

  components: {
    subNav,
    TipCard,
  },

  computed: {
    checked() {
      this.storeMethods = JSON.parse(localStorage.getItem("comparedItems"));
      for (let i = 0; i < this.storeMethods.length; i++) {
        if (this.storeMethods[i].slug == this.methode.slug) {
          this.storeIndex = i;
        }
      }
      this.countSelected = this.storeMethods[this.storeIndex].methods.length;
      // check if this id is in the comparedItems array
      return this.storeMethods[this.storeIndex].methods.includes(
        this.methode.id
      );
    },
    checkboxValue() {
      return "methodcheck" + this.methode.id;
    },
  },

  methods: {
    showLightboxDemoWaarden: function (index) {
      // Fill the lightbox with content
      let demoValueTitle = this.methode.values[index].waarde;
      let demoValueLong = this.methode.values[index].lang;

      let lightBoxHtml = "<h2>" + demoValueTitle + "</h2>";
      lightBoxHtml += "<p>" + demoValueLong.replace(/\n/g, "<br />") + "</p>";

      let lightboxContent = document.getElementById("lightbox-content");
      lightboxContent.innerHTML = lightBoxHtml;

      document.getElementById("lightbox").classList.toggle("active");
    },

    getMethodeDetail() {
      let mid = this.$route.params.methodeId;
      const url = new URL(
        process.env.VUE_APP_REST_URL + ENDPOINT_NAME + "?method=" + mid
      );

      this.isLoading = true;
      this.isEmptyResult = false;

      // fetch(url)
      axios
        .get(url)
        .then((r) => {
          const results = r.data;
          if (!results) {
            this.methode = [];
            this.isEmptyResult = true;
          } else {
            this.methode = r.data.methode;
            this.tipsArray = this.getTips(0);
            if (this.methode.values.length > 0) {
              this.active = this.methode.values[0];
            }
          }
        })
        .catch((error) => {
          console.warn(error);
        });
    },

    showTips: function (waardeIndex) {
      // wordt er een specifieke waarde meegegeven (vanuit click in pagina of bij aanroep van de pagina)?
      waardeIndex !== "undefined" ? waardeIndex : 0;
      // dit toont de tips bij een democratische waarde
      if (this.methode.values[waardeIndex].tips) {
        let tipsContent =
          "<h4><strong>" +
          this.methode.values[waardeIndex].waarde +
          "</strong> bij " +
          this.methode.name_short +
          "</h4>" +
          "<p>" +
          this.methode.values[waardeIndex].tekst +
          "</p>";
        let tipsLength = this.methode.values[waardeIndex].tips.length;
        let tipsArray = this.methode.values[waardeIndex].tips;

        for (var i = 0; i < tipsLength; i++) {
          let tipIsChecked = true;
          if (localStorage.getItem("hiddenTips")) {
            this.hiddenTips = JSON.parse(localStorage.getItem("hiddenTips"));
            if (hiddenTips.indexOf(tipsArray[i]["id"])) tipIsChecked = false;
          }

          tipsContent +=
            '<p><span class="c-detail__checktip"><input type="checkbox" name="checktip" id="tipcheck_' +
            tipsArray[i]["id"] +
            '" v-on:change="changeTipChecked(\'' +
            tipsArray[i]["id"] +
            '\')" checked="' +
            tipIsChecked +
            '"><label for="tipcheck_' +
            tipsArray[i]["id"] +
            '" id="' +
            tipsArray[i]["id"] +
            '">in PDF</label></span><span class="red">Tip:</span> ' +
            tipsArray[i]["value"] +
            "</p>";
        }
        this.tips = tipsContent;
      }
    },

    getTips: function (waardeIndex) {
      // check of pagina wordt aangeroepen met een specifieke waarde (click 'lees de tips' vanuit vergelijk pagina)
      waardeIndex !== "undefined" ? waardeIndex : 0;
      let holdTips = [];
      // dit toont de tips bij een democratische waarde
      if (this.methode.values[waardeIndex].tips) {
        holdTips["waarde"] = this.methode.values[waardeIndex].waarde;
        holdTips["method"] = this.methode.name_short;
        holdTips["beschrijving"] = this.methode.values[waardeIndex].tekst;
        holdTips["tips"] = [];

        let tipsLength = this.methode.values[waardeIndex].tips.length;
        let tipsArray = this.methode.values[waardeIndex].tips;

        if (localStorage.getItem("hiddenTips"))
          this.hiddenTips = JSON.parse(localStorage.getItem("hiddenTips"));

        for (var i = 0; i < tipsLength; i++) {
          let tipIsChecked = true;
          let tipIdasString = tipsArray[i]["id"].toString();
          if (this.hiddenTips.indexOf(tipIdasString) > -1) {
            tipIsChecked = false;
          }
          let thistip = [];
          thistip["checkboxvalue"] = "tipcheck_" + tipsArray[i]["id"];
          thistip["id"] = tipsArray[i]["id"];
          thistip["value"] = tipsArray[i]["value"];
          thistip["checked"] = tipIsChecked;

          holdTips["tips"][i] = thistip;
        }
        return holdTips;
      }
    },

    getTipsWaarde: function (index, waarde) {
      this.active = waarde;
      this.tipsArray = this.getTips(index);
    },

    saveMethod: function (event) {
      // use these variables
      let method = this.methode.id;
      let idx = this.storeIndex;
      let isChecked = event.target.checked;

      if (isChecked) {
        // push the id of the method in checkedMethods[i].methods[]
        this.storeMethods[idx].methods.push(this.methode.id);
        this.saveCats();
      }
      if (!isChecked) {
        // remove the id of the method from checkedMethods[i].methods[]
        this.storeMethods[idx].methods.splice(
          this.storeMethods[idx].methods.indexOf(method),
          1
        );
        this.saveCats();
      }
    },
    saveCats() {
      // save in localStorage
      const parsed = JSON.stringify(this.storeMethods);
      localStorage.setItem("comparedItems", parsed);
    },

    // update count and array selected methods for comparison page
    onUpdateCount(countVal) {},

    cleanClass(j) {
      return j.replace(/ \/ /g, "");
    },

    changeTipChecked: function (event) {
      alert("tip uit pdf gehaald!");
    },
  },

  created() {
    this.slug = this.$route.params.slug;
    setTimeout(() => this.getMethodeDetail(), 50);
  },

  mounted() {
    if (!localStorage.getItem("hiddenTips")) {
      const parsed = JSON.stringify(this.hiddenTips);
      localStorage.setItem("hiddenTips", parsed);
    }
    this.hiddenTips = JSON.parse(localStorage.getItem("hiddenTips"));
  },
};
</script>

